import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let TooltipComp;

class Tooltip extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: TooltipComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/lyte-components/tooltip-comp" */
      "../../../components/javascript/lyte-components/tooltip-comp"
    ).then(function(res) {
      TooltipComp = res.TooltipComp;
    }));

    
;
  }
}

export { Tooltip };
